import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import * as actions from 'store/modules/content/actions';
import { HeaderLoggedIn } from 'scenes/Header';
import connect from 'react-redux/es/connect/connect';
import buildPrice from 'helpers/buildPrice';

import ReactPixel from 'react-facebook-pixel';

class Thanks extends Component {
  componentDidMount() {
    const { details } = this.props;
    ReactPixel.track('Purchase', {
      value: buildPrice(details.count_of_domains, details.subscription_plan),
      currency: 'USD',
    });
    ReactPixel.track('Subscribe', {
      value: buildPrice(details.count_of_domains, details.subscription_plan),
      currency: 'USD',
      predicted_ltv: '0.00',
    });
  }

  render() {
    return (
      <div className="thanks-page">
        <HeaderLoggedIn />
        <div className="profile container thanks-page__container center">
          <p className="billing-header thanks">Thank you!</p>
          <p className="billing-plan">Your payment processed successfully</p>
          <Link to="/domain" className="btn btn-blue">
            Go to Dashboard
          </Link>
        </div>
        <div className="thanks-page__footer">
          <div className="circle_1" />
          <div className="circle_2" />
          <div className="circle_3" />
        </div>
      </div>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
  };
}
export default connect(
  mapStateProps,
  actions,
)(Thanks);



// WEBPACK FOOTER //
// ./src/scenes/Thanks/Thanks.js